exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shared-storage{color:#fff;font-family:Open Sans,Arial,Helvetica,sans-serif;font-weight:100}.brd-saskey-input-container{cursor:pointer}.brd-saskey-input{color:#3292d3}.brd-saskey-input-label{color:#fff}.brd-sas-examples{margin:0}.brd-sas-links,a:link,a:visited{color:#3292d3}a:hover{color:aqua}a:active{color:#3292d3}.brd-sas-p{margin:0;padding:0}.copy-key md-icon{margin-right:8px;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./app/shared-storage/shared-storage.less
// module id = ./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/shared-storage/shared-storage.less
// module chunks = 8